import { RouteObject } from 'react-router-dom';
import { SurveyViewPage } from './pages/survey-view/survey-view.page';
import { SurveyRoutes } from './constants';
import { SurveyShareViewPage } from './pages/survey-view/survey-share-view.page';

export const SurveyModuleRouter: RouteObject[] = [
	{
		path: SurveyRoutes.Root,
		element: <SurveyViewPage />,
		handle: {
			title: 'headers.survey',
			needsDrawer: false,
		},
	},
	{
		path: SurveyRoutes.QrCodeRoot,
		element: <SurveyShareViewPage />,
		handle: {
			title: 'headers.survey',
			needsDrawer: false,
		},
	},
	{
		path: SurveyRoutes.ManualEditing,
		element: <SurveyViewPage />,
		handle: {
			title: 'headers.survey',
			needsDrawer: false,
		},
	},
];
